var map = {
	"./1000SHIB.png": "/nK8",
	"./1INCH.png": "AsUW",
	"./AAVE.png": "8L7A",
	"./ACH.png": "VN91",
	"./ADA.png": "N926",
	"./AGLD.png": "GLH+",
	"./AKRO.png": "c9ZQ",
	"./ALGO.png": "Sjx7",
	"./ALICE.png": "bL9r",
	"./ANC.png": "gH73",
	"./ANKR.png": "7p2U",
	"./ANT.png": "wwwk",
	"./AR.png": "jJsg",
	"./ATA.png": "aoj1",
	"./ATOM.png": "NmkY",
	"./AUDIO.png": "CpJd",
	"./AVAX.png": "XVG8",
	"./AXS.png": "cQy8",
	"./BADGER.png": "2r94",
	"./BAGS.png": "aiRv",
	"./BCH.png": "enzr",
	"./BEL.png": "1HFx",
	"./BIT.png": "Y2q1",
	"./BNB.png": "kUPr",
	"./BNT.png": "doUS",
	"./BSV.png": "F3Na",
	"./BTC.png": "orO4",
	"./BTCDOM.png": "+bDT",
	"./BTC_Deribit_files/translate_24dp.png": "JaNq",
	"./BTC_options.png": "8+uC",
	"./BTM.png": "rpGf",
	"./BTS.png": "H0E4",
	"./BZRX.png": "6fvj",
	"./BZZ.png": "9bAn",
	"./Binance.png": "LXiI",
	"./Bitget.png": "BYtn",
	"./Bitmex.png": "+HaA",
	"./Bybit.png": "Aazv",
	"./C98.png": "rmnO",
	"./CAKE.png": "CGc2",
	"./CELR.png": "/j/P",
	"./CFX.png": "hlT2",
	"./CHR.png": "xj1/",
	"./CHZ.png": "Ut2+",
	"./CLV.png": "NWK/",
	"./CONV.png": "RwRU",
	"./COTI.png": "T//j",
	"./CQT.png": "jF3/",
	"./CRO.png": "aQgt",
	"./CRV.png": "zVET",
	"./CSPR.png": "35hi",
	"./CTK.png": "vKCR",
	"./CTSI.png": "Y0ji",
	"./CVC.png": "Gf8U",
	"./DASH.png": "0kO3",
	"./DEFI.png": "BcK6",
	"./DENT.png": "MpEC",
	"./DGB.png": "a49O",
	"./DODO.png": "HFzh",
	"./DOGE.png": "j+9s",
	"./DORA.png": "Yves",
	"./DOT.png": "htAA",
	"./DYDX.png": "ISnH",
	"./Deribit.png": "qjbA",
	"./EFI.png": "JRf6",
	"./EGLD.png": "HvtG",
	"./ENJ.png": "Eu5E",
	"./EOS.png": "DR3a",
	"./ETC.png": "Yx4Q",
	"./ETH.png": "83Jj",
	"./FIL.png": "I8IJ",
	"./FLM.png": "c6WK",
	"./FLOW.png": "PuDr",
	"./FRONT.png": "qOL9",
	"./FTM.png": "vNT4",
	"./FTT.png": "doKf",
	"./GRT.png": "/0No",
	"./GTC.png": "AzKB",
	"./Gate.png": "eyDT",
	"./HBAR.png": "hPp8",
	"./HNT.png": "A0kp",
	"./HOT.png": "CxPz",
	"./Huobi.png": "C6Wa",
	"./ICP.png": "2cAP",
	"./ICX.png": "JpJS",
	"./IOST.png": "mBXy",
	"./IOTA.png": "BVKh",
	"./JST.png": "2uUi",
	"./KEEP.png": "UCzu",
	"./KNC.png": "4+x2",
	"./KSM.png": "eOuS",
	"./LAT.png": "N/5z",
	"./LINA.png": "UBgL",
	"./LINK.png": "DNJo",
	"./LIT.png": "kjXd",
	"./LON.png": "qJu+",
	"./LPT.png": "sxi0",
	"./LRC.png": "1wQt",
	"./LTC.png": "YIkw",
	"./LUNA.png": "2/DX",
	"./MANA.png": "wjAh",
	"./MASK.png": "/3a5",
	"./MASS.png": "Gjc+",
	"./MATIC.png": "xQ85",
	"./MDX.png": "7NW/",
	"./MINA.png": "EnQk",
	"./MIR.png": "1H2O",
	"./MKR.png": "tZHP",
	"./MTL.png": "4SyD",
	"./NEAR.png": "xphe",
	"./NEO.png": "hOPD",
	"./NKN.png": "b8Pw",
	"./O3.png": "Ya6Z",
	"./OCEAN.png": "SC/Z",
	"./OGN.png": "wBc9",
	"./OKB.png": "ksCX",
	"./OMG.png": "Plxk",
	"./ONE.png": "U311",
	"./ONT.png": "XlI9",
	"./PERP.png": "RiCm",
	"./PHA.png": "0Nbu",
	"./QTUM.png": "BZHr",
	"./RAY.png": "vLfy",
	"./REEF.png": "05Rs",
	"./REN.png": "59RA",
	"./RLC.png": "sYBb",
	"./RNDR.png": "lknO",
	"./RNT.png": "okWY",
	"./RSR.png": "eldI",
	"./RTA.png": "ArJb",
	"./RUNE.png": "5ItR",
	"./RVN.png": "yViS",
	"./SAND.png": "llTo",
	"./SC.png": "hAX0",
	"./SFP.png": "UjSO",
	"./SHIB.png": "dfVu",
	"./SKL.png": "Xn1M",
	"./SLP.png": "a6C+",
	"./SOL.png": "QATi",
	"./STMX.png": "Dr0y",
	"./STORJ.png": "dXUm",
	"./SUN.png": "aXvo",
	"./SUSHI.png": "gnDe",
	"./SWRV.png": "s9LZ",
	"./SXP.png": "KfcZ",
	"./THETA.png": "4I7K",
	"./TLM.png": "xi9R",
	"./TOMO.png": "4r/7",
	"./TORN.png": "QBMt",
	"./TRB.png": "MlYO",
	"./TRIBE.png": "rFve",
	"./TRX.png": "cTKI",
	"./UMA.png": "vnuV",
	"./UNFI.png": "8ehn",
	"./UNI.png": "rXg7",
	"./USDT.png": "KxEw",
	"./VET.png": "rMgd",
	"./WAXP.png": "dn6k",
	"./WNCG.png": "zI75",
	"./WNXM.png": "ljf/",
	"./WOO.png": "vNRu",
	"./XCH.png": "Y4HC",
	"./XEM.png": "5yOP",
	"./XLM.png": "kweT",
	"./XMR.png": "ZCJN",
	"./XRP.png": "N/On",
	"./XTZ.png": "krVo",
	"./YFI.png": "+lCE",
	"./YFII.png": "Zw49",
	"./YGG.png": "V4fy",
	"./ZEC.png": "vzOC",
	"./ZEN.png": "2AUB",
	"./ZIL.png": "fPvz",
	"./ZKS.png": "7ATp",
	"./ZRX.png": "gvuB",
	"./alpha.png": "IBwn",
	"./arrow-down.png": "OhMl",
	"./bake.png": "W/LG",
	"./bal.png": "Q66Z",
	"./band.png": "wXUq",
	"./bat.png": "6Vs3",
	"./blank.png": "/wyZ",
	"./blz.png": "go8t",
	"./calendar-illustration.png": "ylAt",
	"./comp.png": "/fSD",
	"./index.png": "mbg2",
	"./kava.png": "4fi8",
	"./logo-black.png": "FNH6",
	"./pixinvent-logo.png": "lbia",
	"./snx.png": "Q0s5",
	"./srm.png": "sDbA",
	"./waves.png": "91jf",
	"./xz2.png": "OEf4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "x+0Q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencyIcon ^\.\/.*\.png$
// module id = x+0Q
// module chunks = 1